<template>
	<core-page class="omapi-monsterleads-wrapper">
		<h1>{{ $route.meta.title }}</h1>
		<div class="omapi-monsterleads">
			<monsterleads-table></monsterleads-table>
		</div>
	</core-page>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapGetters, mapActions } = createNamespacedHelpers('monsterleads')

export default {
	name     : 'MonsterLeads',
	computed : {
		...mapState([ 'export' ]),
		...mapGetters([ 'exportQueryString' ]),
	},
	methods : {
		downloadExport () {
			this.$api.get('leads/export' + this.exportQueryString)
				.responseType('blob')
				.then((response) => {
					const url = window.URL.createObjectURL(new Blob([ response.body ]))
					const link = document.createElement('a')
					link.href = url
					link.setAttribute('download', 'MonsterLeads.' + this.export.type)
					document.body.appendChild(link)
					link.click()
				})
		},
		...mapActions(
			[
				'updateCampaignFilters',
				'updateSiteFilters',
				'updateTagFilters',
				'updateStartDate',
				'updateEndDate',
				'updateSearch',
				'fetchLeads',
			]
		),
	},
	mounted () {
		this.fetchLeads()
	},
}
</script>

<style lang="scss">
	.omapi-datepicker-inline {
		display: flex;
		justify-content: space-between;
	}
</style>
